module.exports = __webpack_public_path__ + "static/media/ChairCracked_Before.0ddb5cbf.jpg";